<template>
  <section class="breadcrumbs-custom">      
    <div class="breadcrumbs-custom-footer">
      <div class="container">
        <ul class="breadcrumbs-custom-path">
          <li><router-link to="/">Home</router-link></li>            
          <li class="active">My Account</li>
        </ul>
      </div>
    </div>
  </section>

  <!-- Tabs and Accordion-->
  <section class="section section-xl bg-default text-md-start">
    <div class="container">
      <div class="row row-30 justify-content-center justify-content-xl-between">         
        <div class="col-md-12 col-xl-12">
          <h3 class="no-uppercase">
            Welcome {{ authStore.user?.first_name }} {{ authStore.user?.last_name }}
          </h3>

          <!-- Bootstrap tabs-->
          <div class="tabs-custom tabs-horizontal tabs-line" id="tabs-1">
            <div class="nav-tabs-wrap">
              <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    :class="{ active: activeTab === 'dashboard' }"
                    @click="setActiveTab('dashboard')"
                    data-bs-toggle="tab"
                    type="button"
                  >
                    Dashboard
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    :class="{ active: activeTab === 'my-account' }"
                    @click="setActiveTab('my-account')"
                    data-bs-toggle="tab"
                    type="button"
                  >
                    My Account
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    :class="{ active: activeTab === 'my-orders' }"
                    @click="setActiveTab('my-orders')"
                    data-bs-toggle="tab"
                    type="button"
                  >
                    My Orders
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    :class="{ active: activeTab === 'change-password' }"
                    @click="setActiveTab('change-password')"
                    data-bs-toggle="tab"
                    type="button"
                  >
                    Change Password
                  </button>
                </li>
              </ul>
            </div>

            <!-- Tab panes -->
            <div class="tab-content">
              <div v-if="activeTab === 'dashboard'" class="tab-pane fade show active">
                <Dashboard />
              </div>
              <div v-if="activeTab === 'my-account'" class="tab-pane fade show active">
                <MyAccount />
              </div>
              <div v-if="activeTab === 'my-orders'" class="tab-pane fade show active">
                <MyOrders />
              </div>
              <div v-if="activeTab === 'change-password'" class="tab-pane fade show active">
                <ChangePassword />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue'
import { useCartStore } from '@/stores/cart'
import { useAuthStore } from '@/stores/authStore'
import Dashboard from '@/components/user-profile/Dashboard.vue'
import MyAccount from '@/components/user-profile/MyAccount.vue'
import MyOrders from '@/components/user-profile/MyOrders.vue'
import ChangePassword from '@/components/user-profile/ChangePassword.vue'

const authStore = useAuthStore()
const cartStore = useCartStore()
const activeTab = ref('dashboard') // default tab

function setActiveTab(tab) {
  activeTab.value = tab
}

onMounted(async () => {
  await nextTick()
  cartStore.loadCart()

  const scriptId = 'script-js-script'
  const existingScript = document.getElementById(scriptId)
  if (existingScript) existingScript.remove()

  const newScript = document.createElement('script')
  newScript.src = '/assets/js/script.js'
  newScript.id = scriptId
  document.body.appendChild(newScript)
})
</script>
